import { LegalDocumentPage } from "./LegalDocumentPage";

export function LegalNoticePage() {
  return <LegalDocumentPage docKey="legal_notice" sectionCount={5} />;
}
